if (!customElements.get("swiper-slider")) {
  class SwiperSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.slideContainer = this.querySelector("[data-swiper]:not([data-swiper-thumbs])");
      this.video = false;
      if (this.dataset.swiperVideo) {
        this.video = true;
      }
      this.slides = this.querySelectorAll("[data-swiper-slide]");
      this.isVideoSlider = this.hasAttribute('video-slider');
      this.sliderOptions = this.applyDefaultOptions(this.getSliderOptions());
      this.activeIndex = 0;
      this.initialized = false;
      if (this.dataset.swiperThumbs) {
        this.thumbnails = this.querySelector('[data-swiper-thumbs]');
      }
      if (this.dataset.customEvent) {
        this.attachCustomListeners(this.dataset.customEvent);
      }
      if (this.slideContainer && this.slides.length > 0) {
        document.addEventListener(
          "DOMContentLoaded",
          this.initializeSwiper.bind(this)
        );
        document.addEventListener(
          "shopify:section:load",
          this.initializeSwiper.bind(this)
        );
        document.addEventListener(
          "td:section-rendered",
          this.initializeSwiper.bind(this)
        );
        window.addEventListener("resize", this.handleResize.bind(this));

        this.addEventListener("go-to-slide", this.goToSlide.bind(this));

        this.addEventListener("update-variant-image", this.updateVariantImage.bind(this));
        
        this.addEventListener("update-slides", this.updateSlides.bind(this));
      } else {
        console.warn("SwiperSlider - Slider or Slides Not Found");
      }
    }

    attachCustomListeners(customEvent) {
      switch (customEvent) {
        case "swiper_event":
          document.addEventListener("swiper_event", this.updateSlides.bind(this));
          break;
      }
    }

    updateSlides(evt) {
      this.slider.appendSlide(evt.detail.slides);
      this.goToSlide(evt);
      if(this.slider.thumbs) {
        this.slider.thumbs.swiper.update();
      }
      this.slider.update();
    }

    updateVariantImage(evt) {
      const variantFeaturedImageId = evt.detail.id;
      const imageIds = this.querySelectorAll("[data-image-id]")

      if (imageIds) {
        imageIds.forEach(element => {
          let imageId = element.getAttribute("data-image-id")
          if (imageId == variantFeaturedImageId) {
            let index = element.getAttribute("data-position");
            if(index){
              this.slider.slideTo(index);
            } 
          }
        });        
      }
    }
  
    goToSlide(index) {
      if (this.slider) {
        if (index < 0 || index >= this.slider.slides.length) {
          console.warn("SwiperSlider - Invalid slide index in goToSlide method");
          return;
        }
        this.slider.slideTo(index, 1000, false);
        const slideVideo = this.slider.slides[this.slider.activeIndex].querySelector('video');
        if (slideVideo) {
          slideVideo.currentTime = 0;
        }
      } else {
        console.warn("SwiperSlider - Swiper not initialized in goToSlide method");
      }
    } 

    handleSlideMedia(prevSlide, currentSlide){
      if (currentSlide) {
        const currentSlideMedia = currentSlide.querySelector('video');
        if (currentSlideMedia) {
          currentSlideMedia.currentTime = 0;
          currentSlideMedia.play();
        }
      }
  
      if(prevSlide != undefined) {
        const prevSlideMedia = prevSlide.querySelector('video');
        if (prevSlideMedia) {
          prevSlideMedia.pause();
        }
      } 
    }

    applyDefaultOptions(options) {
      if (options.loop === undefined) {
        options.loop = false;
      }
      options.speed = 400;
      return options;
    }

    getSliderOptions() {
      try {
        return JSON.parse(this.dataset.swiperOptions);
      } catch (err) {
        console.log(err);
        return {};
      }
    }

    initializeSwiper() {
      if (window.Swiper && !this.initialized) {
        this.initialized = true;
        if(this.thumbnails) {
          this.setThumbnails()
        }
        if (this.video) {
          this.dispatchVideoEvent()
        }
        this.slider = new Swiper(this.slideContainer, this.sliderOptions);
        this.initializeSliderEventListeners();
        //add class to locked slider wrapper
        if (this.slider.isLocked) {
          this.classList.add('td-swiper-is-locked');
        }
        this.dispatchEvent(new CustomEvent('slider-initialized'));
      } else if (!window.Swiper) {
        console.warn("SwiperSlider - Swiper.js not found");
      }
    }
    dispatchVideoEvent() {
      const swiperElm = this;
      this.sliderOptions.on = {
      	slideChange: function () {
          swiperElm.dispatchEvent(new CustomEvent("swiperSlideChanged", {detail: {slide_id: this.activeIndex}, bubbles: true}));
        }
      }
    }

    handleResize(e) {
      if (this.slider) {
        setTimeout(() => {
          this.slider.updateSize();
        }, 300);
      }
    }

    setThumbnails() {
      const thumbsSlideContainer = this.thumbnails;
      const thumbOptions = JSON.parse(this.thumbnails.dataset.swiperOptions);
      const thumbnailsSlider = new Swiper(thumbsSlideContainer, thumbOptions);
      this.sliderOptions.thumbs = { swiper: thumbnailsSlider };
    }

    preventFocusScroll() {
      if (!this.slider) {
        return;
      }

      // Get all focusable elements in the carousel
      const focusableElements = this.querySelectorAll(
        'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])',
      );

      focusableElements.forEach((element) => {
        element.addEventListener(
          "focus",
          (e) => {
            // Prevent the browser's automatic scroll-into-view
            e.preventDefault();

            // Use scrollIntoView with block: 'nearest' to only scroll if actually needed
            element.scrollIntoView({
              behavior: "auto",
              block: "nearest",
              inline: "nearest",
            });
          },
          { passive: false },
        );
      });
    }

    initializeSliderEventListeners() {
      if (this.slider) {
        this.slider.on("lock", () => {
          this.classList.add("td-swiper-is-locked");
        });
        this.slider.on("unlock", () => {
          this.classList.remove("td-swiper-is-locked");
        });

        // Prevent carousel auto-scroll when tabbing between visible slides
        this.preventFocusScroll();
      }

      if (this.isVideoSlider && this.slider) {
        this.slider.on("slideChange", () => {
          const prevSlide = this.slider.slides[this.slider.previousIndex];
          const currentSlide = this.slider.slides[this.slider.activeIndex];
          if (currentSlide) {
            currentSlide.removeAttribute("video-paused");
          }
          this.handleSlideMedia(prevSlide, currentSlide);
        }) 

        this.slides.forEach(slide => {
          slide.addEventListener('click', () => {
            const slideVideo = slide.querySelector('video');
            
            if (slideVideo) {
              if(slideVideo.paused){
                slide.removeAttribute('video-paused')
                slideVideo.play();
              }else{
                slide.setAttribute('video-paused',"")
                slideVideo.pause();
              }
            }
          })
        })
      }
    }
  }
  customElements.define("swiper-slider", SwiperSlider);

  if (!customElements.get("td-ugc-slider")) {
    class tdUgcSlider extends SwiperSlider {
      constructor() {
        super();
        this.PROGRESS_BAR = this.querySelector('[data-swiper-progress-bar]');
        this.PRODUCT_CARDS = this.querySelectorAll('.td-ugc-slider__product-card');
      }
  
      connectedCallback() {
        super.connectedCallback();
        document.addEventListener('reset-swiper', () => {
          this.handleReinitializeEvent();
        });
        document.addEventListener('pause-swiper', () => {
          this.pauseAutoplay();
        });
        this.addEventListener('slider-initialized', () => {
          if (this.PROGRESS_BAR) {
            this.initializeSliderEventListeners();
            this.updateProgressBar();
          }
          this.updateProductCards();
        });
      }

      setupArrowKeyNavigation() {
        if (!this.slider) {
          return;
        }

        // Attach keydown listener to each card
        this.slider.slides.forEach((slide, index) => {
          const card = slide.querySelector("[data-icon-modal-trigger]");
          if (card) {          
            card.addEventListener("keydown", (e) => {
              if (e.key === "ArrowLeft") {
                e.preventDefault();
                this.slider.slidePrev();
              } else if (e.key === "ArrowRight") {
                e.preventDefault();
                this.slider.slideNext();
              }
            });
          }
        });
      }

      updateSlideInertStates() {
        if (!this.slider) {
          return;
        }

        // First, make ALL slides unfocusable via roving tabindex
        this.slider.slides.forEach((slide, index) => {
          const card = slide.querySelector("[data-icon-modal-trigger]");
          if (card) {
            card.setAttribute("tabindex", "-1");
          }
        });

        // Then, make ONLY the active slide's card focusable
        const activeSlide = this.querySelector(".swiper-slide-active");
        if (activeSlide) {
          const activeCard = activeSlide.querySelector(
            "[data-icon-modal-trigger]",
          );
          if (activeCard) {
            activeCard.setAttribute("tabindex", "0");
          }
        }
      }

      initializeSliderEventListeners() {
        // Call parent class initialization
        super.initializeSliderEventListeners();

        if (this.slider) {
          this.slider.on('slideChangeTransitionStart', () => {
            this.updateProductCards();
            if (this.PROGRESS_BAR) {
              this.PROGRESS_BAR.style.transition = 'none';
              this.PROGRESS_BAR.style.width = '0%';
            }
          });

          this.slider.on("slideChangeTransitionEnd", () => {
            if (this.PROGRESS_BAR) {
              this.updateProgressBar();
            }
          });

          if (this.PROGRESS_BAR) {
            this.slider.on("slideChange", () => {
              if (this.slider.touches.diff !== 0) {
                if (this.slider.params.autoplay.disableOnInteraction) {
                  this.slider.params.autoplay.disableOnInteraction = false;
                }
                this.slider.autoplay.start();
              }
            });
          }

          // UGC slider specific: Accessibility for modal cards
          // Use setTimeout to ensure Swiper has created loop duplicates before setting tabindex
          setTimeout(() => {
            this.updateSlideInertStates();
            this.setupArrowKeyNavigation();
          }, 100);

          this.slider.on("slideChange", () => {
            // Check if user was focused on a card before slide changed
            const wasFocusedOnCard =
              this.querySelector("[data-icon-modal-trigger]:focus") !== null;

            this.updateSlideInertStates();

            // If user was navigating with arrow keys, maintain focus on new active card
            if (wasFocusedOnCard) {
              const newActiveCard = this.slider.slides[
                this.slider.activeIndex
              ]?.querySelector("[data-icon-modal-trigger]");
              if (newActiveCard) {
                newActiveCard.focus();
              }
            }
          });

          this.slider.on("resize", () => {
            this.updateSlideInertStates();
          });
        }
      }
      
      updateProgressBar() {
        if (this.PROGRESS_BAR) {
          super.connectedCallback();
          const slideDuration = this.slider?.params?.autoplay?.delay - 200;
          this.PROGRESS_BAR.style.transition = 'none';
          this.PROGRESS_BAR.style.width = '0%';
          this.PROGRESS_BAR.offsetWidth; 
          this.PROGRESS_BAR.style.transition = `width ${slideDuration}ms linear`;
          this.PROGRESS_BAR.style.width = '100%';
        }
      }
  
      updateProductCards() {
        this.PRODUCT_CARDS.forEach((card) => {
          if (card.classList.contains('td-active')) {
            card.classList.remove('td-active')
          }
        });
        const sliderActiveIndex = this.slider?.activeIndex;
        const activeSlide = this.slider?.slides[sliderActiveIndex];
        const activeProductCard = this.querySelector(`#${activeSlide.dataset?.productCard}`);
        activeProductCard.classList.add('td-active');
      }
  
      listenForReinitializeEvent() {
        document.addEventListener('reinitialize-swiper', () => {
          if (this.PROGRESS_BAR) {
            this.handleReinitializeEvent();
          }
        });
      }

      handleReinitializeEvent() {
        super.connectedCallback();
        this.resetProgressBar();
        this.updateProgressBar();
        this.updateProductCards();

      }

      resetProgressBar() {
        if (this.PROGRESS_BAR) {
          this.PROGRESS_BAR.style.transition = 'none';
          this.PROGRESS_BAR.style.width = '0%';
          if (this.slider.params.autoplay.disableOnInteraction) {
            this.slider.params.autoplay.disableOnInteraction = false;
          }
          this.slider.autoplay.start();
        }
      }

      pauseAutoplay() {
        if (this.slider && this.slider.autoplay) {
          this.slider.autoplay.stop();
        }
      }
    }
  
    customElements.define('td-ugc-slider', tdUgcSlider);
  }
}